import {
  QIcon_feedback_fluent_delivery,
  QIcon_feedback_logical_comprehensive_answer,
  QIcon_feedback_precise_language,
  QIcon_feedback_proactive_attitude,
  QIcon_various_expressions,
} from '@repo/icons/index'
import { SVGProps } from 'react'
import { IKeyword } from '../../../../model/feedback.interface'

type keywordKeyType = keyof typeof IKeyword
type IconMapType = {
  [key in keywordKeyType]: React.FC<SVGProps<SVGSVGElement>>
}
type KoreanMapType = {
  [key in keywordKeyType]: string
}
const IconMap: IconMapType = {
  'Used Various Expressions': QIcon_various_expressions,
  'Precise Language Use': QIcon_feedback_precise_language,
  'Fluent Delivery': QIcon_feedback_fluent_delivery,
  'Logical & Comprehensive Answer': QIcon_feedback_logical_comprehensive_answer,
  'Depth of Understanding': QIcon_feedback_logical_comprehensive_answer,
  'Proactive Attitude': QIcon_feedback_proactive_attitude,
  'Quick Acquisition': QIcon_feedback_proactive_attitude,
  'Engaging Conversation': QIcon_feedback_proactive_attitude,
  'Thorough Preparation': QIcon_feedback_proactive_attitude,
}
const KoreanMap: KoreanMapType = {
  'Used Various Expressions': '다양한 표현 사용',
  'Precise Language Use': '정확한 언어 사용',
  'Fluent Delivery': '유창한 전달력',
  'Logical & Comprehensive Answer': '논리적이고 풍부한 답변',
  'Depth of Understanding': '높은 주제 이해도',
  'Proactive Attitude': '적극적인 참여',
  'Quick Acquisition': '빠른 습득력',
  'Engaging Conversation': '즐거운 대화',
  'Thorough Preparation': '수업 준비도',
}

interface IKeywordCard {
  title: string
  subTitle?: string
  badge?: 'Popular' | 'New' | string
}

const KeywordCard = ({ title, badge = '', subTitle = '' }: IKeywordCard) => {
  const Icon = IconMap[title]
  return (
    <div className="border-1 relative flex h-[124px] w-[248px] flex-col items-start justify-between rounded-[8px] border-gray-200 px-[16px] py-[12px]">
      <div className="flex flex-col items-start justify-start">
        <div className="text-[16px] font-bold text-black">{title}</div>
        {!!subTitle && <div className="text-[14px] text-gray-600">{subTitle}</div>}
      </div>
      <div className="flex w-full flex-row items-end justify-end">
        {badge === 'Popular' ? (
          <span className="absolute left-[16px] bottom-[12px] text-[12px] text-purple-500">Popular</span>
        ) : badge === 'New' ? (
          <span className="absolute left-[16px] bottom-[12px] text-[12px] text-red-400">New</span>
        ) : (
          <span />
        )}

        <Icon width={40} height={40} className="absolute right-[16px] bottom-[12px]" />
      </div>
    </div>
  )
}

export default KeywordCard
